import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    TextField,
} from "@material-ui/core"
import { useState } from "react"
import { RegistrarLogErro } from "../../../services/clientefiel"
import useAppStore from "../../../stores/AppStore"

export default function DialogCancelamento(props) {
    const [motivoCancelamento, setMotivoCancelamento] = useState(undefined)
    const [observacao, setObservacao] = useState("")

    const cancelarPedido = useAppStore(s => s.cancelarPedido)

    const autorizacao = localStorage.getItem("chaveSistema")

    const handleChange = e => setObservacao(e.target.value)

    const handleClose = () => {
        setObservacao("")
        setMotivoCancelamento(undefined)
        props.setConfirmarCancelamento(null)
    }

    const handleCancelar = async () => {
        try {
            if (!motivoCancelamento) {
                props.alertStart("Selecione o motivo do cancelamento", "warning")
                return
            }

            if (observacao.length <= 3) {
                props.alertStart(
                    "O motivo do cancelamento deve ter mais de 3 caracteres",
                    "warning"
                )
                return
            }

            props.setLoading(true)

            const response = await cancelarPedido(
                props.confirmarCancelamento,
                observacao,
                props.listaMotivoCancelamento[motivoCancelamento]
            )

            if (!response) {
                props.alertStart("Erro inesperado ao cancelar pedido", "error")
                return
            }

            if (response?.retornoErro) {
                props.alertStart(response.mensagem, "error")
                return
            }

            handleClose()
        } catch (error) {
            RegistrarLogErro(error, "cancelarPedido", {
                observacao,
                motivoCancelamento,
                pedido: props.confirmarCancelamento,
                autorizacao,
            })

            props.alertStart(error?.message || "Erro inesperado cancelarPedido", "error")
        } finally {
            props.setLoading(false)
        }
    }

    return (
        <Dialog open={!!props.confirmarCancelamento} onClose={handleClose} maxWidth="xs">
            <DialogTitle>Confirmação</DialogTitle>
            <DialogContent>
                <FormControl variant="outlined" fullWidth>
                    <InputLabel>Motivo</InputLabel>
                    <Select
                        native
                        fullWidth
                        value={motivoCancelamento}
                        onChange={e => setMotivoCancelamento(e.target.value)}
                        label="Motivo"
                    >
                        <option value={undefined}>Selecione um motivo</option>
                        {Object.keys(props.listaMotivoCancelamento).map((motivoIndex, index) => {
                            const motivo = props.listaMotivoCancelamento[motivoIndex]

                            return <option value={index}>{motivo.description}</option>
                        })}
                    </Select>
                </FormControl>
                <TextField
                    label="Observação"
                    multiline
                    fullWidth
                    minRows={4}
                    variant="outlined"
                    value={observacao}
                    onChange={handleChange}
                    margin="normal"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} fullWidth variant="contained">
                    NÃO CANCELAR
                </Button>
                <Button
                    onClick={handleCancelar}
                    variant="contained"
                    fullWidth
                    style={{
                        backgroundColor: "#dc3545",
                        color: "white",
                    }}
                >
                    CANCELAR
                </Button>
            </DialogActions>
        </Dialog>
    )
}
